import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const testimonials = [
  {
    name: 'Sarah Chen',
    role: 'VP of People Operations',
    company: 'TechFlow Solutions',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10d60e496-1763295319842.png",
    avatarAlt: 'Professional headshot of Asian woman with long black hair wearing navy blazer and white blouse',
    quote: 'Bee Wise transformed our onboarding from a chaotic mess into a streamlined experience. New hires are productive 3x faster, and our managers finally have time to focus on strategic work instead of answering the same questions repeatedly.',
    rating: 5,
    metric: '€120k saved annually'
  },
  {
    name: 'Marcus Rodriguez',
    role: 'Head of Engineering',
    company: 'DataStream Analytics',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_108dbe7bd-1763296216235.png",
    avatarAlt: 'Professional headshot of Hispanic man with short black hair wearing dark suit and blue tie',
    quote: 'The gamification aspect is brilliant. Our junior developers are actually excited about onboarding tasks. The AI assistant handles 80% of common questions, and the structured knowledge delivery means everyone gets consistent information.',
    rating: 5,
    metric: '94% retention rate'
  },
  {
    name: 'Emma Thompson',
    role: 'Chief HR Officer',
    company: 'CloudScale Systems',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_164bebd69-1763293730639.png",
    avatarAlt: 'Professional headshot of Caucasian woman with blonde hair in elegant gray suit',
    quote: 'We scaled from 50 to 200 employees in 18 months, and Bee Wise was essential to maintaining quality onboarding. The ROI was clear within 3 months, and employee satisfaction scores increased by 40%.',
    rating: 5,
    metric: '40% satisfaction increase'
  }];


  return (
    <section className="py-20 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Trusted by Forward-Thinking Companies
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See how industry leaders transformed their employee onboarding with Bee Wise
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300">

              <div className="flex items-center gap-3 mb-4">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />

                <div>
                  <h4 className="font-semibold text-foreground">{testimonial?.name}</h4>
                  <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="Star" size={16} color="var(--color-primary)" strokeWidth={0} className="fill-primary" />
              )}
              </div>

              <p className="text-muted-foreground leading-relaxed mb-4 italic">
                "{testimonial?.quote}"
              </p>

              <div className="border-t border-border pt-4 flex items-center justify-between">
                <span className="text-sm text-muted-foreground">{testimonial?.company}</span>
                <span className="text-sm font-semibold text-success">{testimonial?.metric}</span>
              </div>
            </div>
          )}
        </div>

        <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border border-primary/20 rounded-lg p-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            {[
            { value: '500+', label: 'Companies Trust Us' },
            { value: '50k+', label: 'Employees Onboarded' },
            { value: '4.9/5', label: 'Customer Rating' },
            { value: '€2.5M+', label: 'Total Savings Generated' }]?.
            map((stat, index) =>
            <div key={index}>
                <div className="text-3xl font-bold text-primary mb-2">{stat?.value}</div>
                <div className="text-sm text-muted-foreground">{stat?.label}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;